import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Gift, Building2, Clock, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";

export default function CustomerVouchers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/vouchers/mine").then((r) => setItems(r.data || [])).catch(() => setItems([])); }, []);

  const active = items.filter((v) => v.status === "active");
  const others = items.filter((v) => v.status !== "active");

  return (
    <div className="max-w-4xl mx-auto px-3 sm:px-6 py-4 sm:py-8" data-testid="customer-vouchers">
      <h1 className="font-display text-2xl sm:text-4xl font-bold text-blue-950 flex items-center gap-2 mb-1">
        <Gift size={24} className="sm:hidden"/><Gift size={28} className="hidden sm:inline"/> Meus Vouchers
      </h1>
      <p className="text-stone-500 text-xs sm:text-sm mb-4 sm:mb-6">Vouchers exclusivos das lojas parceiras. Apresente o código no caixa da loja emissora.</p>

      <h2 className="font-display text-base sm:text-xl font-bold text-stone-900 mb-2 sm:mb-3">Ativos ({active.length})</h2>
      {active.length === 0 ? (
        <Card className="p-4 sm:p-6 text-center text-stone-400 rounded-2xl border-stone-200 text-xs sm:text-sm">
          Você ainda não tem vouchers ativos. <Link to="/" className="text-blue-900 font-bold">Explorar lojas →</Link>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          {active.map((v) => (
            <Card key={v.id} className="p-3 sm:p-5 rounded-2xl border-2 border-blue-300 bg-gradient-to-br from-blue-50 to-white" data-testid={`voucher-mine-${v.code}`}>
              <div className="flex items-center gap-1.5 text-blue-700 text-[10px] sm:text-xs uppercase tracking-wider font-bold"><Building2 size={12}/>{v.company_name}</div>
              <div className="font-display text-2xl sm:text-4xl font-bold text-stone-900 mt-1 sm:mt-2">B$ {v.value.toFixed(2).replace(".", ",")}</div>
              <div className="mt-2 sm:mt-3 p-2 sm:p-3 rounded-xl bg-white border-2 border-dashed border-stone-300 text-center">
                <div className="text-[9px] sm:text-[10px] uppercase tracking-widest text-stone-500 font-bold">Código do voucher</div>
                <div className="font-mono text-lg sm:text-2xl font-extrabold text-blue-950 tracking-wider mt-0.5 sm:mt-1">{v.code}</div>
                <div className="mt-1.5 sm:mt-2 inline-block p-1 sm:p-1.5 bg-white rounded-lg" data-testid={`voucher-mine-qr-${v.code}`}>
                  <QRCodeSVG value={v.code} size={96} level="H" includeMargin={false}/>
                </div>
                <div className="text-[9px] sm:text-[10px] text-stone-500 mt-0.5 sm:mt-1">Apresente o QR ou o código no caixa</div>
              </div>
              <div className="flex items-center gap-1 text-[10px] sm:text-xs text-stone-500 mt-2 sm:mt-3"><Clock size={11}/>Válido até {new Date(v.expires_at).toLocaleDateString("pt-BR")}</div>
            </Card>
          ))}
        </div>
      )}

      {others.length > 0 && (
        <>
          <h2 className="font-display text-base sm:text-xl font-bold text-stone-900 mt-6 sm:mt-8 mb-2 sm:mb-3">Histórico ({others.length})</h2>
          <Card className="rounded-2xl border-stone-200 overflow-hidden overflow-x-auto">
            <table className="w-full text-xs sm:text-sm">
              <thead className="bg-stone-50 text-[10px] sm:text-xs uppercase tracking-wider text-stone-600">
                <tr><th className="text-left px-2 sm:px-3 py-2">Loja</th><th className="text-left px-2 sm:px-3 py-2">Código</th><th className="text-left px-2 sm:px-3 py-2">Valor</th><th className="text-left px-2 sm:px-3 py-2">Status</th></tr>
              </thead>
              <tbody>
                {others.map((v) => (
                  <tr key={v.id} className="border-t border-stone-100">
                    <td className="px-2 sm:px-3 py-2">{v.company_name}</td>
                    <td className="px-2 sm:px-3 py-2 font-mono text-[10px] sm:text-xs">{v.code}</td>
                    <td className="px-2 sm:px-3 py-2">B$ {v.value.toFixed(2).replace(".", ",")}</td>
                    <td className="px-2 sm:px-3 py-2">
                      {v.status === "used" && <span className="text-stone-500 text-[10px] sm:text-xs font-bold uppercase flex items-center gap-1"><CheckCircle2 size={11}/>Usado</span>}
                      {v.status === "expired" && <span className="text-red-600 text-[10px] sm:text-xs font-bold uppercase">Expirado</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </>
      )}
    </div>
  );
}
